import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import './Login.css';
import { app,auth,facebookAuthProvider } from "./base";

class Login extends Component{
    constructor(props, state){
        super(props);
        this.state = state;
        
        this.authWithEmailPassword = this.authWithEmailPassword.bind(this);
        this.authWithFacebook = this.authWithFacebook.bind(this);
        this.authWithGoogle = this.authWithGoogle.bind(this);
        this.handleClose = this.handleClose.bind(this);
        

    }
    componentWillMount() {
       this.setState({ redirect: false,
        unknownUser:false });
    }
    authWithEmailPassword(event){
    event.preventDefault();
    console.log("We're authing with Email & password");
    console.table([{
        email: this.emailInput.value,
        password: this.passwordInput.value,
        userName: this.userNameInput.value,
        }]);

        const userName = this.userNameInput.value;
        const email = this.emailInput.value;
        const password = this.passwordInput.value;
        let isNewUser = false; 

        // check if userNAme is unique and valid

        console.log(' login app.validateUserName()',this.props.validateUserName(userName));

        auth.fetchProvidersForEmail(email).then((providers)=>{
            console.log('app.auth.fetchProvidersForEMail then (providers) !',providers);
            if(providers.length === 0) {
            // create user
                console.log('create user!');
                console.warn("User is unknown");
                isNewUser = true;
                this.setState({ redirect: false,
                    unknownUser:true });
                /*return app.auth().createUserWithEmailAndPassword(email,password)
                    .then((user) => {
                        user.updateProfile({
                            displayName: userName
                        });
                        this.props.onNewUser(user,userName,email,password);
                        this.loginForm.reset()
                        this.setState({ redirect: true })
                        return user;
                    })
                    .catch(err=>console.error(err));*/
            } else if(providers.indexOf("password") === -1){
                console.log('Try alternative login');
            } else {
                // log in user
                console.log('log in user');
                return app.auth().signInWithEmailAndPassword(email,password)
            }
        })
        .then((user) => {
                 //   displayName: userName
            console.log('--------------------!user was logged in userName,user:',user,isNewUser);
            //this.props.onUserLogin(user,userName,email,password);
            if (user && user.email) {
              //this.loginForm.reset();
              //this.props.onUserLogin(user,userName,email,password);
              this.handleClose();
            }
          })
        .catch((error) => {
            
          });
//retinafunk@gmail.com
    }
    authWithFacebook(){
        console.log("We're authing with Facebook");
    }
    authWithGoogle(){
        console.log("We're authing with Google");  
    }

    handleClose(event){
        console.log('handleClose',event);
        this.setState({
            redirect : true
        });
    }

    render(){
        console.log("this.state.redirect ",this.state.redirect );  
        return(
            this.state.redirect ? 
            <Redirect to="/"/>
            :
            <div className="modal is-active">
                <div onClick={this.handleClose} className="modal-background"></div>
                <div className="modal-content">
                <div className="box login">
                    <header>
                        <h1> Anmelden</h1>
                        <p className="small">
                            Bitte melden Sie sich mit Ihre E-Mail und Passwort an um den Kalender zu nutzen.
                            Dazu müssen Sie bei uns als Nutzer bereits registriert und freigeschaltet sein.  
                        </p>
                        <p></p>
                    </header>
                    <form onSubmit={(event)=> this.authWithEmailPassword(event)} ref={(form) => { this.loginForm = form }}>
                       <input ref={(input) =>{this.userNameInput = input}} name="username" type="hidden"  placeholder="Name" required />
                        <div className="field">
                            <label className="label">E-Mail</label>
                            <p className="control has-icons-left has-icons-right">
                                <input required ref={(input) =>{this.emailInput = input}} name="email" className="input" type="email" placeholder="Email" />
                                <span className="icon is-small is-left">
                                    <ion-icon name="mail"></ion-icon>
                                </span>
                                    <span className="icon is-small is-right">
                                    <ion-icon name="checkmark"></ion-icon>
                                </span>
                            </p>
                        </div>

                        <div className="field">
                            <label className="label">Passwort</label>
                            <p className="control has-icons-left has-icons-right">
                                <input required className="input" ref={(input) =>{this.passwordInput = input}} name="password" type="password" placeholder="Passwort" />
                                <span className="icon is-small is-left">
                                    <ion-icon name="lock"></ion-icon>
                                </span>
                                    <span className="icon is-small is-right">
                                    <ion-icon name="checkmark"></ion-icon>
                                </span>
                            </p>
                        </div>

                        {
                            this.state.unknownUser ? <div className="error-msg" >
                            <p>Diese Nutzer E-Mail ist entweder nicht registriert oder der Passwort ist falsch.</p>
                        </div> : ''
                        } 

                        <div className="field is-grouped">
                            <div className="control">
                                <input type="submit" className="button is-success button-primary" value="Weiter"></input>
                            </div>
                            <div className="control">
                            <button className="button is-text is-outlined has-margin-left"  onClick={this.handleClose}>Abbrechen</button>
                            </div>
                        </div>

                       
                    </form>
                </div>
                </div>
            <button onClick={this.handleClose} className="modal-close is-large" aria-label="close"></button>
            </div>

        ); 
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/Login.js